import { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import "./index.css";

// Some document URLs come back from the backend with a
// `Content-Disposition: attachment` header, which makes a direct <iframe src={url}>
// force a native "Save As" download instead of rendering the PDF inline. Fetching
// the bytes ourselves and handing the iframe a blob: URL sidesteps that header
// entirely, since it's no longer a top-level navigation to the original URL.
const DocumentPreviewModal = ({ title, url, onClose }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setBlobUrl(null);
    setHasError(false);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load document");
        return res.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setHasError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return (
    <div className="doc-preview-overlay" onClick={onClose}>
      <div className="doc-preview-container" onClick={(e) => e.stopPropagation()}>
        <div className="doc-preview-heading">
          <h4>{title}</h4>
          <button className="doc-preview-close-btn" onClick={onClose} type="button">
            <BsX size={26} />
          </button>
        </div>

        {hasError ? (
          <div className="doc-preview-error">Unable to load this document.</div>
        ) : blobUrl ? (
          <iframe title={title} src={`${blobUrl}#navpanes=0`} className="doc-preview-iframe" />
        ) : (
          <div className="doc-preview-loading">Loading…</div>
        )}
      </div>
    </div>
  );
};

export default DocumentPreviewModal;
